// extracted by mini-css-extract-plugin
export default {"container":"TableBodyContainer_container__NBu1i"};